// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 84 ? "9b0008ae" : chunkId) + "." + {"84":"43d5cf54d7b2fc26","714":"8c89f0c07db3ce83"}[chunkId] + ".js";
};